import Papa from 'papaparse';
import {downloadCSV} from '../Reports/ReportHelpers';
import {SECTION_TITLES} from "../containers/AnswersList";

// multiple response answers
export function multiResponseAnswerExport(responseArr, section, secQuestions, categories, translation){
  var responseAnswerArr = responseArr.map((response) => response.answers)
  var nameArr = ["","","","",""]
  var headerArr = ["ID", "Question", "Category", "Description", "Possible Answers"] //,"Answer1","Bookmarked1", "Note1", "Answer2","Bookmarked2", "Note2"]
  responseArr.forEach((response, index) => {
    let num = index + 1
    nameArr.push(num + ". " + response.commonName + " Scientific Name: " + response.scientificName + " Fleet: " + response.fleet + " Geography: " + response.geography, "", "")
    headerArr.push("Answer " + num , "Bookmarked " + num, "Note " + num)
  })
  let rows = [nameArr, headerArr];

  secQuestions.forEach((question) => {
    let possibleAnswers = question.answers.map((a) => a.title).join("\n");
    var category = categories.find((c) => c.id === question.category);

    var qTitle = question.title
    var catTitle = category.title
    var desc = question.description

    if(translation){
      var trQ = translation.questions.find(trQ => trQ.engID === question.id)
      if(trQ){
        qTitle = trQ.title
        desc = trQ.description
        let catTr = translation.categories.find((c) => c.engID === category.id)
        catTitle = catTr ? catTr.title : catTitle
        possibleAnswers = trQ.answers.map((a) => a.title).join("\n");
      }
    }

    let ansRow = [question.id, qTitle.replace(/<.*?>/gm, ''), catTitle , desc.replace(/<.*?>/gm, ''), possibleAnswers]
    responseAnswerArr.forEach((answers) => {
      let answer = answers[question.id] ? question.answers.find((a) => a.id === answers[question.id].value) : null;
      if (answer) {
        var answerText = answer.title

        if(translation && trQ){
          answerText = trQ.answers.find(a => a.id === answer.id).title
        }
        var note = answers[question.id].note ? answers[question.id].note : ""; //TODO: return textversion call when putting back into code
        var bookmark = answers[question.id].flagged ? "Yes" : "";
        ansRow.push(answerText, bookmark, note)
      } else {
        ansRow.push("Not Answered", "", "")
      }
    })
    rows.push(ansRow)
  }
)

  var csv = Papa.unparse(rows);
  downloadCSV(csv, "Multi Answers Summary - " + SECTION_TITLES[section])
}


export function multiResponseOptionExport(responseArr, section, options, categories, calculateResults){
  var nameArr = ["",""]
  var headerArr = ["Option", "Category" ]
  var resultsList = {}
  responseArr.forEach((response, index) => {
    let num = index + 1
    nameArr.push(num + ": " + response.commonName + " Scientific Name: " + response.scientificName + " Fleet: " + response.fleet + " Geography: " + response.geography, "", "", "", "", "")
    headerArr.push(num + ": Top Option", num + ": Note")
    if(section !== "controlRules"){
      headerArr.push(num + ": Failed Criteria", num + ": Met Criteria")
      nameArr.push("", "")
    }
    headerArr.push(num + ": Red", num + ": Orange", num + ": Yellow", num + ": Green")
    let result = calculateResults(response.answers)
    resultsList[response.metadata.id]={results:result}
  })

  let rows = [nameArr, headerArr];

  var options = options.forEach((option) => {
    if(option.section === section){
      var category = categories.find((c) => c.id === option.category.id);
      let catTitle = category ? category.title : null
      var optionRow = [option.title, catTitle]

      responseArr.forEach((response) => {
        if(response.userEdits){
          let topOpt = (response.userEdits[section] && response.userEdits[section].starred && response.userEdits[section].starred.includes(option.id)) ? "Yes" : ""
          let note = (response.userEdits.userNotes && response.userEdits.userNotes[option.id]) ? response.userEdits.userNotes[option.id] : ""
          optionRow.push(topOpt, note)
        } else {
          optionRow.push("","")
        }

        let optionResult = resultsList[response.metadata.id].results[section].options.find(opt => opt.id === option.id)
        if(section !== "controlRules"){
          optionRow.push(
            optionResult.eliminatedBy.length,
            optionResult.metCriteria.length
          )
        }

        optionRow.push(
          optionResult.caveats.filter((c) => c.score === -3 && !c.static).length,
          optionResult.caveats.filter((c) => c.score === -2 && !c.static).length,
          optionResult.caveats.filter((c) => c.score === -1 && !c.static).length,
          optionResult.caveats.filter((c) => c.score === 2 && !c.static).length)

      })
      rows.push(optionRow)
    }
  });
  var csv = Papa.unparse(rows);
  downloadCSV(csv, "Multi Options Summary - " + SECTION_TITLES[section])
}
